module.exports = __webpack_public_path__ + "images/emoji/green_book.74808b29bc352a17873b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/green_book.png
// module id = hLeN
// module chunks = 14